import React, { FC, useEffect, useState } from 'react'
import { Button, Modal } from '@wmgtech/legato'

import { initConfetti, renderConfetti } from 'shared/utils/canvasAnimation'
import {
  CANVAS_ANIMATION_DELAY_TO_SHOW,
  CANVAS_ANIMATION_FIXED_HEIGHT,
  CANVAS_ANIMATION_FIXED_WIDTH
} from 'modules/Projects/constants'

import { IProjectSuccessModal } from './ProjectSuccessModal.props'
import rocker from './rocker-without-hand.svg'
import { cn } from 'shared/utils'
import { ConditionRender } from 'components'
import './ProjectSuccessModal.scss'

const ProjectSuccessModal: FC<IProjectSuccessModal> = ({
  onCloseHandler,
  body,
  footer,
  isOpen = true,
  classList = ''
}) => {
  const [canvasRef, setCanvasRef] = useState<HTMLCanvasElement | null>(null)

  useEffect(() => {
    if (canvasRef) {
      const ctx = canvasRef.getContext('2d')

      if (ctx) {
        canvasRef.width = CANVAS_ANIMATION_FIXED_WIDTH
        canvasRef.height = CANVAS_ANIMATION_FIXED_HEIGHT

        setTimeout(() => {
          initConfetti(canvasRef)
          renderConfetti(ctx, canvasRef)
        }, CANVAS_ANIMATION_DELAY_TO_SHOW)
      }
    }
  }, [canvasRef])


  return (
    <Modal
      className={cn('project-success-modal', classList)}
      icon=""
      onClose={onCloseHandler}
      shouldCloseOnOverlayClick={true}
      title=""
      isOpen={isOpen}
    >
      <div className="project-success-modal__canvas-box">
        <canvas className="project-success-modal__canvas" ref={setCanvasRef} />
      </div>
      <div className="project-success-modal__content">
        <h2 className="project-success-modal__title">Huzzah!</h2>
        <p className="project-success-modal__description">
          <ConditionRender
            condition={!body}
            component={
              <>
                You successfully activated this project to your Storybox Zone. Thank you for taking the time on this
                project. We hope it is a great success!
              </>
            }
          />
          <ConditionRender condition={!!body} component={<>{body}</>} />
        </p>

        <img className="project-success-modal__img" src={rocker} alt="Rocker" />
        <svg
          className="project-success-modal__img"
          width="171"
          height="247"
          viewBox="0 0 171 247"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            className="project-success-modal__img-hand"
            d="M100.01 152.917C93.3063 156.418 88.9198 163.244 88.9198 163.244C81.4974 171.672 69.5645 174.738 60.4445 172.491C49.5774 169.823 42.9356 151.689 42.3161 144.676C39.5652 147.133 36.8887 148.362 36.8887 148.362C42.3656 162.636 47.7558 173.199 58.7841 176.972C65.8224 179.38 80.6052 177.195 91.9309 168.246C93.8143 168.085 96.9369 169.562 99.7869 167.651C102.773 170.121 102.117 172.491 103.665 173.037C106.577 171.846 106.441 169.636 100.654 164.498C107.68 164.237 108.312 170.654 108.932 169.065C111.98 165.851 105.152 160.315 100.072 161.047C108.349 155.301 110.072 164.945 112.054 161.618C114.248 159.682 107.94 154.494 100.89 157.187C107.42 150.522 111.992 157.237 112.55 155.313C114.818 151.465 105.896 149.814 100.01 152.905V152.917Z"
            fill="#E5BAAC"
          />
        </svg>
        <ConditionRender
          condition={!footer}
          component={
            <Button
              className="project-success-modal__btn"
              containerStyle="solid"
              colorType="info"
              onClick={onCloseHandler}
            >
              Close
            </Button>
          }
        />

        <ConditionRender condition={!!footer} component={<>{footer}</>} />
      </div>
    </Modal>
  )
}

export default ProjectSuccessModal
